export const SERVER_ALL_VALUE: string = 'All'
export const SERVER_NONE_VALUE: string = 'None'
export const SERVER_UNKNOWN_VALUE: string = 'Unknown'

export const AKIXI_CME_NAME: string = 'Akixi'
export const DEFAULT_CME_ID: string = 'd6d6c5a5f0f90d60:-15617a00:169f533f6d5:5613'
